import { useEvent } from "../../changelog-item-context";

import CreateEventTitle from "./CreateEventTitle";
import CreateVersionEventTitle from "./CreateVersionEventTitle";
import DeleteEventTitle from "./DeleteEventTitle";
import DeployLabelEventTitle from "./DeployLabelEventTitle";
import DuplicateEventTitle from "./DuplicateEventTitle";
import LabelActionEventTitle from "./LabelActionEventTitle";
import RenameEventTitle from "./RenameEventTitle";
import RunBatchEventTitle from "./RunBatchEventTitle";
import SimpleEventTitle from "./SimpleEventTitle";
import UpdateDatasetEventTitle from "./UpdateDatasetEventTitle";

import { ActionType } from "@/queries";

const SIMPLE_ACTIONS = new Set([ActionType.UPDATE, ActionType.MOVE, ActionType.CUSTOM]);

const LABEL_ACTIONS = new Set([
  ActionType.CREATE_LABEL,
  ActionType.DELETE_LABEL,
  ActionType.MOVE_LABEL,
]);

const EventTitle = () => {
  const event = useEvent();
  const { action_type } = event;

  if (SIMPLE_ACTIONS.has(action_type)) {
    return <SimpleEventTitle actionType={action_type} />;
  }

  if (LABEL_ACTIONS.has(action_type)) {
    return <LabelActionEventTitle actionType={action_type} />;
  }

  switch (action_type) {
    case ActionType.CREATE:
      return <CreateEventTitle />;
    case ActionType.CREATE_VERSION:
      return <CreateVersionEventTitle />;
    case ActionType.DELETE:
      return <DeleteEventTitle />;
    case ActionType.DUPLICATE:
      return <DuplicateEventTitle />;
    case ActionType.RENAME:
      return <RenameEventTitle />;
    case ActionType.RUN_BATCH:
      return <RunBatchEventTitle />;
    case ActionType.UPDATE_DATASET:
      return <UpdateDatasetEventTitle />;
    case ActionType.DEPLOY_LABEL:
      return <DeployLabelEventTitle />;
    default:
      return <SimpleEventTitle actionType={action_type} />;
  }
};

export default EventTitle;
